import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { BookingSession, HotelDetail, RoomTypeResult, TemporaryRoomTypeSelection } from "../../../Models";
import dayjs = require("dayjs");
import RoomSearchFormCard from "./RoomSearchFormCard";
import HotelDetailsComponent from "./HotelDetailsComponent";
import RoomSelectionComponent from "../roomselection/RoomSelectionComponent";
import './HotelDetailsPage.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import RoomSearchCriteria from "../../../states/RoomSearchCriteria";
import MapDialog from "./MapDialog";

interface Attrs {   
    isFetchingRooms?: boolean,
    searchCriteria?: RoomSearchCriteria,
    bookingSession?: BookingSession, 
    messageProvider: MessageProvider,
    hotelDetails: HotelDetail|null,
    roomTypeResults?: RoomTypeResult[],    
    selectedRoomSelections?: TemporaryRoomTypeSelection[],
    attemptingBackNav: boolean,
    onSearchRooms: (searchCriteria:RoomSearchCriteria) =>void,
    onCheckoutRequested: (roomTypeSelections:TemporaryRoomTypeSelection[]) => void;
    onOptionSelected: (selection:TemporaryRoomTypeSelection) => void;
    onOptionRemoved: (selection:TemporaryRoomTypeSelection) => void;
    onChangeAttemptingBackNav: () => void;
    onBackPressed:() => void;
}
export function buildSearchCriteriaDescription(searchCriteria:RoomSearchCriteria, messageProvider:MessageProvider) {
    let dateRangeDescr = dayjs(searchCriteria.getCheckInDate()).format("MMM DD") + " - " + dayjs(searchCriteria.getCheckOutDate()).format("MMM DD");
    
    let numberOfNights = dayjs(searchCriteria.getCheckOutDate()).diff(searchCriteria.getCheckInDate(), 'day');
    let numberOfNightsDescr = numberOfNights + " " + 
        ((numberOfNights == 1)?  messageProvider.get("night") :  messageProvider.get("night"));
    
    let numberOfRoomsDescr = searchCriteria?.getNumberOfRooms() + " " + 
        ((searchCriteria != undefined &&  searchCriteria.getNumberOfRooms() > 1 )? 
        messageProvider.get("rooms"): messageProvider.get("room"));
    let localOrForeignerDescription = searchCriteria?.getGuestType() == 'LOCAL' ?
        messageProvider.get("local") : messageProvider.get("foreigner");

    return dateRangeDescr + " (" + numberOfNightsDescr + ")"  + ", " + numberOfRoomsDescr + ", " + localOrForeignerDescription;

}
function HotelDetailsPage(): m.Component<Attrs> {
    let roomSearchCriteria : RoomSearchCriteria | undefined;
    let expandMap = false;
    return {
        view(vnode) {  
            const {isFetchingRooms, searchCriteria, selectedRoomSelections, attemptingBackNav, hotelDetails, messageProvider, roomTypeResults, 
                bookingSession, onCheckoutRequested, onBackPressed, onChangeAttemptingBackNav, onOptionRemoved, onOptionSelected, onSearchRooms} = vnode.attrs;
                
            roomSearchCriteria= searchCriteria;
            let searchCriteriaDescription = roomSearchCriteria ? 
                                                 buildSearchCriteriaDescription(roomSearchCriteria, messageProvider) 
                                                 :"Search with dates, number of rooms and guest type.";
            return m("div",
                hotelDetails!=null ?                    
                [   
                    m(HotelDetailsComponent,{
                        hotelDetails: hotelDetails,                   
                        messageProvider: messageProvider,
                        onViewMapRequested: () => {
                           expandMap = true
                           console.log("Map is clicked.")
                        }
                    }),
                    
                    [
                        m("div", [
                            m("h5.mt-5", "Search rooms and see the prices"),
                            m(RoomSearchFormCard, {
                                messageProvider : messageProvider,
                                searchCriteria: roomSearchCriteria,
                                onSearch: function(searchCriteria){
                                    if ( searchCriteria ){
                                        onSearchRooms(searchCriteria);
                                    }
                                }
                            }),

                            !isFetchingRooms && roomTypeResults && roomTypeResults.length == 0 ?
                            "":
                            m("div.mt-5", 
                                m("div.row",
                                    m("div.col-md-1",m("p", roomSearchCriteria? "Rooms for" : "Rooms")),
                                    m("div.col-md-11", m("h5", roomSearchCriteria? searchCriteriaDescription : ""))
                                )
                            ),
                            isFetchingRooms?
                            m("div.m-5", 
                                m(LoadingIndicator, {colorScheme: "secondary"})
                            ):
                            (roomTypeResults && roomTypeResults.length==0) ?
                            m("div.mb-5.mt-5",
                                m("p",m("b","Sorry! No rooms available. Please change the dates and search again."))
                            ):
                            m(RoomSelectionComponent,{
                                searchCriteria: roomSearchCriteria,
                                roomTypes: hotelDetails.roomTypes,
                                bookingSession: bookingSession,
                                messageProvider: messageProvider,
                                roomTypeResults: roomTypeResults,
                                selectedRoomSelections: selectedRoomSelections,
                                attemptingBackNav: attemptingBackNav,
                                onCheckoutRequested: function (roomTypeSelections:TemporaryRoomTypeSelection[]) {
                                    console.log("RoomType Selections" , roomTypeSelections);
                                    if(roomTypeSelections){
                                        onCheckoutRequested(roomTypeSelections);
                                    }
                                },
                                onOptionSelected: (selection:TemporaryRoomTypeSelection) => {
                                    onOptionSelected(selection);
                                },
                                onOptionRemoved: (selection:TemporaryRoomTypeSelection) => {
                                    onOptionRemoved(selection);
                                },
                                onChangeAttemptingBackNav: () => {
                                    onChangeAttemptingBackNav();
                                },
                                onBackPressed: () => {
                                    onBackPressed();
                                },
                            }),
                            
                            expandMap? m(MapDialog,{
                                hotelDetails : hotelDetails,
                                onClose: () => {
                                    console.log("Map is closed");
                                    expandMap=false; 
                                    m.redraw();
                                }
                            }):null
                        ])
                    ]
                ]
                :m("div.m-5", 
                    m(LoadingIndicator, {colorScheme: "secondary"})
                )
            )
        }
    }
}

export default HotelDetailsPage;

